export default __webpack_public_path__ + "static/media/logo-porsche.2c039a01.jpg";